<template>
  <b-row>
    <LmButton
      v-if="!isOnPreviewMode && showCancelButton"
      class="col-auto"
      :value="$t('cancel')"
      buttonClass="btn-secondary"
      @click="$router.go(-1)"
    />
    <template v-if="!isOnModeBox">
    <LmButton
      v-for="(item, index) in buttons"
      :key="index"
      class="col-auto"
      :buttonClass="item.buttonClass"
      :value="item.label"
      @click="$router.push(item.click.to)"
    />
    </template>
    <LmButton
      v-if="showReloadButton"
      class="col-auto"
      :isProcessing="isProcessing"
      :value="$t('refresh_to_see_changes')"
      buttonClass="btn-warning"
      @click="$emit('onReloadTable')"
    />
    <LmButton
      v-if="enableMultipleDocumentSignFeature && showMultipleSignButton && valuesSelected.length"
      class="col-auto"
      :isProcessing="isProcessing"
      :value="$t('sign_multiple', {count: valuesSelected.length})"
      buttonClass="btn-success"
      @click="onBeforeSign"
    />
  </b-row>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmDocumentsMixin from '@/mixins/lmDocumentsMixin.js'

export default {
  mixins: [lmDocumentsMixin, lmToasts],
  components: {
    LmButton
  },
  data () {
    return {
      lumbreSignerPort: process.env?.VUE_APP_LUMBRESIGNER_PORT || '8081',
      isProcessing: false
    }
  },
  props: {
    buttons: {
      type: Array
    },
    valuesSelected: {
      type: Array,
      default: () => ([])
    },
    showMultipleSignButton: {
      type: Boolean,
      default: false
    },
    showReloadButton: {
      type: Boolean,
      default: false
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    isOnPreviewMode: {
      type: Boolean,
      default: false
    },
    isOnModeBox: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enableMultipleDocumentSignFeature () {
      return process.env?.VUE_APP_ENABLE_MULTIPLE_DOCUMENT_SIGN === 'yes'
    }
  },
  methods: {
    onBeforeSign () {
      if (this.valuesSelected?.length) {
        this.isProcessing = true
        this.lmModalInformationMessage({
          modalClosable: false,
          modalKeyboard: false,
          resultSubtitle: '',
          buttons: [
            {
              btnText: this.$t('cancel'),
              btnType: 'danger',
              btnGhost: true,
              btnCallback: () => {
                this.isProcessing = false
              }
            },
            {
              btnText: this.$t('sign'),
              btnCallback: () => {
                this.onSign()
              }
            }
          ],
          message: this.$tc('confirmations.start_sign_multiple_confirmation', this.valuesSelected.length, { count: this.valuesSelected.length })
        })
      }
    },
    async onSign () {
      try {
        if (this.valuesSelected?.length) {
          const documentIdsToSign = this.valuesSelected.map(vs => vs.id)

          const classifiedResponse = await commonsApi.axiosPostWrapper(`/documents/documents_by_signature_type`, {
            id: documentIdsToSign
          })

          const documentsClassifiedByType = classifiedResponse.data

          for (const docsByType of documentsClassifiedByType) {
            const documentsToSignOfTheSameType = docsByType.documents.map(d => d._id)
            if (docsByType._id === 'digital') {
              const documentIdsToSignAsQueryString = documentsToSignOfTheSameType.join('&id=')

              if (this.enableLumbredocsSigner) {
                await this.checkLumbreDocsSigner()
                const response = await commonsApi.axiosGetWrapper(`/documents/generatejnlpV2?id=${documentIdsToSignAsQueryString}`)
                await commonsApi.axiosPostWrapper(`http://localhost:${this.lumbreSignerPort}/initSR`, {
                  url: response.data.targetURL
                })
                this.lmNotificationSuccessMessage({
                  message: this.$t('good_title'),
                  description: this.$tc('after_start_sign_multiple_message', this.valuesSelected.length, { count: this.valuesSelected.length })
                })
              } else {
                const tempLink = document.createElement('a')
                tempLink.href = `${process.env?.VUE_APP_API_URL}documents/generatejnlp?id=${documentIdsToSignAsQueryString}`
                tempLink.setAttribute('download', `documento_afirmar.jnlp`)
                tempLink.click()
                this.lmToastSuccessMessage(`Para continuar debe finalizar el proceso de firma desde la aplicacion.`, 'Enviado al Firmador.')
              }
            } else if (docsByType._id === 'electronic_without_otp') {
              commonsApi.axiosPostWrapper(`/documents/sign`, {
                id: documentsToSignOfTheSameType
              })
              this.lmNotificationSuccessMessage({
                message: this.$t('good_title'),
                description: this.$tc('after_start_sign_multiple_message', this.valuesSelected.length, { count: this.valuesSelected.length })
              })
            }
            this.$emit('onRefreshTable')
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    }
  }
}
</script>
